const birdNettingService = {
  id: 1,
  title: "Bird Netting",
  image: "/assets/BirdNetting/Bird Netting4.jpg",
  image1: "/assets/BirdNetting/ Bird Netting.webp",
  image2: "/assets/BirdNetting/ Bird Netting3.jpg",
  image3: "/assets/BirdNetting/ Bird Netting1.jpg",
  shortDescription:
    "Effective and durable bird netting solutions for your property.",
  description:
    "Our Bird Netting service provides a safe and efficient way to protect your property from bird-related issues. Designed to prevent birds from entering unwanted areas, our high-quality nets ensure a clean and bird-free environment while being safe for the birds.",
  description1:
    "We use durable and weather-resistant netting materials suitable for various spaces, including balconies, windows, terraces, and industrial areas. Our team ensures precise installation to cover all vulnerable areas without compromising aesthetics or ventilation.",
  description2:
    "In addition to installation, we offer maintenance and inspection services to ensure the nets remain effective over time. Our bird netting solutions are ideal for residential, commercial, and industrial spaces, guaranteeing a long-lasting and hassle-free experience.",
  benefits: [
    "Prevents birds from entering unwanted areas.",
    "Durable and weather-resistant materials.",
    "Safe for birds and eco-friendly.",
    "Custom installations for various spaces.",
    "Low maintenance and long-lasting results.",
    "Improves cleanliness and hygiene.",
  ],
};

export default birdNettingService;
